import api from "./../service/apiService";
import { apiUrl } from "./../constants/apiUrl";
import axios from 'axios';
import { redirectTo } from './../action/redirection';
import { Pages } from './../constants/actionType';
import { InHomeUtils } from "../util/change/inhomeUtils";
import { InHomeUtils as Utils } from '../util/inhomeUtils';

export const validateInput = (action, dispatch) => {
  dispatch({ type: "CHANGE_VALIDATEINPUT", value: action });
};

const changeDescription = (action, dispatch) => {
  dispatch({ type: "CHANGE_DESCRIPTION", value: action });
};

const getRedirectPath = (inputDetail) => {
  let path = "";
  //path = window.location.hostname.match("localhost") ? "/atom/urc.html" : (inputDetail.SourceType === 'myfios' ? '/personal/urc.nohf.html' : (inputDetail.SourceType === 'nonsignin-token' ? '/personal/shop.html' : '/personal/urc.html'));
  path = '/inhome/change/signin';
  let domainUrl = (window.location.protocol + "//" + window.location.hostname) + ((document.location.href.indexOf("localhost") > -1) ? (":" + window.location.port) : '');
  return domainUrl + path;
};

const getIntent = flowSubType => {
  switch (flowSubType) {
    case "accordion":
      return "ACCORDION";
    case "renew":
      return "RENEWAL";
    case "speedupgrade":
      return "SPEEDUPGRADE";
    case "tvupgrade":
      return "TVUPGRADE";
    case "cba":
      return "CBA";
    case "RentalRouter":
      return "ROUTER";
    case "PurchaseRouter":
      return "ROUTER";
    case "RESTORE":
      return "RESTORE";
    case "RentalRouter":
      return "RENTALROUTER";
    case "PurchaseRouter":
      return "PURCHASEROUTER";
    case "smartcart":
      return "SMARTCARTRESUME";
    case "RentalFNE":
      return "FNE";
    case "PurchaseFNE":
      return "FNE";
    case "Pega":
      return "PEGA";
    default:
      return "ACCORDION";
  }
};

const getvaluePropIndMFRT = mrft => {
  switch (mrft) {

    case "isNurses":
      return "NurseServe0001";
    case "isTeachers":
      return "TeacherServe001";
    case "isFirstResponders":
      return "ResponderServe1";
    case "isMilitary":
      return "MilitaryServe01";
    default:
      return "";
  }
};

const getAccordionCHangeMFRT = flowSubType => {
  switch (flowSubType) {

    case "isNurses":
      return "ACCORDION";
    case "isTeachers":
      return "ACCORDION";
    case "isFirstResponders":
      return "ACCORDION";
    case "isMilitary":
      return "ACCORDION";
    default:
      return flowSubType;
  }
};

export const buildQueryString = inputDetail => {
  let params = [];
  params["flowtype"] = "af";
  let subflowtype = inputDetail.FlowType;
  params["source"] = inputDetail.SourceType;
  //params["promokeyword"] = "12697";

  //params["digitalSecuritySubscriptionType"]="DR_PRM";promokeyword
  const customerIntent = (params["customerintent"] = getIntent(subflowtype));
  if (customerIntent === "PEGA") {
    subflowtype = "renew";
    params["overlay"] = "n";
    params["oneclick"] = "n";
    params["test"] = "bundle";
  }
  if (InHomeUtils.isNotNull(inputDetail.MFRT)&&inputDetail.MFRT==="nurse")
    params["nurse"] = "y";
  if (InHomeUtils.isNotNull(inputDetail.MFRT)&&inputDetail.MFRT==="isACP")
    params["isEBBFlow"] = "Y";
  else if (InHomeUtils.isNotNull(inputDetail.MFRT)&&inputDetail.MFRT==="student")
  params["valuePropInd"] = "CollegeStudent";
  else if (InHomeUtils.isNotNull(inputDetail.MFRT))
    params["valuePropInd"] = getvaluePropIndMFRT(inputDetail.MFRT);
  params["subflowtype"] = subflowtype
  //if ($("#txtFirstVisit")[0] && $("#txtFirstVisit")[0].checked)
  params["FirstVisit"] = "";
  //params["accordion"] = inputDetail.accordion;
  params["FlowRoute"] = inputDetail.FlowRoute;
  if(InHomeUtils.isNotNull(inputDetail.enableinhomeclassictp)) 
    params["enableinhomeclassictp"] = inputDetail.enableinhomeclassictp;
  else if(InHomeUtils.isNotNull(inputDetail.enableinhomeclassicdp)) 
    params["enableinhomeclassicdp"] = inputDetail.enableinhomeclassicdp;
  else if(InHomeUtils.isNotNull(inputDetail.enableinhomeclassicsa)) 
    params["enableinhomeclassicsa"] = inputDetail.enableinhomeclassicsa;
  else if(InHomeUtils.isNotNull(inputDetail.enableInHomeHSI)) 
    params["enableInHomeHSI"] = inputDetail.enableInHomeHSI;
  else if (InHomeUtils.isNotNull(inputDetail.qamless)) 
  params["qamless"] = inputDetail.qamless; 
  else if (InHomeUtils.isNotNull(inputDetail.FQGLoyalty)) 
  params["FQGLoyalty"] = inputDetail.FQGLoyalty;
  else if (InHomeUtils.isNotNull(inputDetail.pegaMandM)) 
  params["pegaMandM"] = inputDetail.pegaMandM;  
  else if(InHomeUtils.isNotNull(inputDetail.EnableSubmit) || InHomeUtils.isNotNull(inputDetail.isPortedAccount) 
    || InHomeUtils.isNotNull(inputDetail.SkipPegaRecommendation)){
    if(inputDetail.EnableSubmit==='y'){
      params['EnableSubmitOrder'] = inputDetail.EnableSubmit
    }
    if(inputDetail.isPortedAccount==='y'){
    /*params["digitalSecuritySubscriptionType"]="DR_PRM";
      params["IsocId"]="R4466"
      params["digitalSecurityAction"]="Enroll";
      params["PackageId"]="1234"
      */

     // params["homesecurity_dark_testing"]="Y"

      params['isPortedAccount'] = inputDetail.isPortedAccount
    } 
    if(inputDetail.SkipPegaRecommendation) {
      params['skippega'] = 'y'
    }
    if(inputDetail.loadVHA){
      params["digitalSecuritySubscriptionType"]="DR_PRM";
      params["IsocId"]="R4466"
      params["digitalSecurityAction"]="Enroll";
      params["PackageId"]="1234"    }
  }
  //if ($("#txtLOF")[0] && $("#txtLOF")[0].checked) params["LOF"] = "Y";
  //if ($("#abTest")) params["test"] = $("#abTest").val();

  if (!!inputDetail.PN && inputDetail.PN !== null && inputDetail.PN !== "") {
    params["PN"] = inputDetail.PN;
  }

  var esc = encodeURIComponent;
  return Object.keys(params)
    .map(function (k) {
      return esc(k) + "=" + esc(params[k]);
    })
    .join("&");
};

const getTokeninfo = inputDetail => {
  let item = {};
  item["flowtype"] = "af";
  item["EnableSmartcart"] = "y";
  item["subflowtype"] = inputDetail.FlowType;
  item["source"] = inputDetail.SourceType;
  item["overlay"] = "";
  item["oneclick"] = "";
  item["customerintent"] = getIntent(inputDetail.FlowType);
  if (InHomeUtils.isNotNull(inputDetail.MFRT))
    item["valuePropInd"] = getvaluePropIndMFRT(inputDetail.MFRT);
  return JSON.stringify(getJsonObject(item));
};

const getJsonObject = item => {
  return {
    flowtype: item["flowtype"],
    subflowtype: item["subflowtype"],
    source: item["source"],
    overlay: item["overlay"],
    oneclick: item["oneclick"],
    customerintent: item["customerintent"]
  };
};

const EncryptUserInfo = (plainText, type, tokenType) => {
  let url = apiUrl().encryptUrl + "?plainText=" + plainText + "&type=" + type + "&tokenType=" + tokenType;
  api(url, 'GET', '')
    .then(response => {
      if (response != null) {
        if (response.data != undefined && response.data != null && response.data.encryptedValue != undefined) {
          return response.data.encryptedValue
        }
        else { return ""; }
      }
      else { return ""; }
    })
    .catch(error => {

    });
  return "";
};

export const submit = (dispatch, visitId, inputDetail, cookies, flag) => {
  dispatch({
    type: 'LOADER_ACTIVE',
    value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
  });
  let resp = flag?.includes('MN=Y') ?  "&isMnFlow=Y" : "";
  let wifi = flag?.includes('agency=CETCORDER2') ?  "&agency=CETCORDER2" : "";
  let agencyID = new URLSearchParams(window.location?.search)?.get('agency');
  if(agencyID !== null && agencyID !== undefined){
    window.sessionStorage.setItem('agencyID', agencyID);
  }
  let url = apiUrl().encryptUrl + "?plainText=" + encodeURIComponent('vcustid=' + inputDetail.Vcustid + ';vactid=' + inputDetail.Vactid + ';state=' + inputDetail.State + ';PN=' + inputDetail.PN) + "&type=USERINFO&tokenType=";
  api(url, 'GET', '')
    .then(response => {
      if (response != null) {
        if (response.data != undefined && response.data != null && response.data.encryptedValue != undefined) {
          let domain = "localhost";
          if (document.location.href.indexOf("localhost") === -1) {
            domain = "verizon.com";
          }
          if(resp) {
            window.sessionStorage.setItem('isMidnight', true);
          }
          if(wifi){
            window.sessionStorage.setItem('isWIFI7', true);
          }
          Utils.deleteCookie('userinfo')
          cookies.set('userinfo', response.data.encryptedValue, { path: '/', 'domain': domain });
          cookies.set(document.domain.indexOf("www.verizon.com") != -1 ? 'wlnvztssoid' : 'wlnvztssoid_sit', "Y", { path: '/', 'domain': domain });

          //window.location.href = getRedirectPath() + "?" + buildQueryString(inputDetail);  
          
           redirectTo(Pages.ECSignIn + "?" + buildQueryString(inputDetail), dispatch);
          
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
        else {
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
          return "";
        }
      }
      else {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        return "";
      }
    })
    .catch(error => {
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    });
  return "";
};

// M+H OneClick Ordering
export const setActiveView = (viewType, dispatch) => {
  dispatch({
    type: 'SET_CHANGE_APP_ACTIVE_VIEW',
    value: viewType
  })
}

export const setVzwAccountNumber = (accountNumber, dispatch) => {
  dispatch({
    type: 'SET_VZW_ACCOUNT_NUMBER',
    value: accountNumber
  });
}

export const setVzwAccountDetails = (accountDetails, dispatch) => {
  dispatch({
    type: 'SET_VZW_ACCOUNT_DETAILS',
    value: accountDetails
  });
};

export const setVzwAccountRadioBtn = (value, dispatch) => {
  dispatch({
    type: 'SET_VZW_ACCOUNT_RADIO_BTN',
    value: value
  });
};

export const saveVzwAccountDetails = (accountNumber, accountDetails, dispatch) => {

  try {
    let saveUrl = apiUrl().mnhOneClickVzwAccountSave + accountNumber;
    let reqObj = JSON.stringify(JSON.parse(accountDetails));
    api(saveUrl, 'POST', reqObj).then(response => {
      console.log("Got response from save call ", response);
      let callStatus = response && response.data;
      if (callStatus === "OK") {
        dispatch({
          type: 'SHOW_MLP_OPTIONS',
          value: true
        });
      }
      dispatch({
        type: 'SET_QUAL_SAVE_CALL_STATUS',
        value: callStatus
      });
    })
      .catch(error => {
        console.log("Error on save call ", error);
      });

  } catch (ex) {
    console.log("Exception on save call ", ex);
  }
};

export const setRedirectQueryString = (queryString, dispatch) => {
  dispatch({
    type: 'SET_REDIRECT_QUERY_STRING',
    value: queryString
  });
};

export const fiosQualification = (mnhOneClickProps, dispatch) => {

  return new Promise((resolve, reject) => {
    try {
      const { vzwAccountNumber, crmmStandaloneResp, crmmBundleResponse, crmmPromoResponse, crmmEquipmentResponse, crmmVasResponse, vzwOfferEligibilityResp, mhToken, visitProfilejson } = mnhOneClickProps;
      const reqObj = {
        mhToken: vzwAccountNumber || mhToken || '',
        crmmStandaloneResponse: crmmStandaloneResp || '',
        crmmBundleResponse: crmmBundleResponse || '',
        crmmPromoResponse: crmmPromoResponse || '',
        crmmEquipmentResponse: crmmEquipmentResponse || '',
        crmmVasResponse: crmmVasResponse || '',
        vzwOfferEligibilityResponse: vzwOfferEligibilityResp || '',
        visitProfilejson: visitProfilejson || ''
      };

      let fiosQualUrl = apiUrl().mnhOneClickQualification;
      if (crmmStandaloneResp || crmmBundleResponse || crmmPromoResponse || crmmEquipmentResponse || crmmVasResponse || vzwOfferEligibilityResp) {
        fiosQualUrl = apiUrl().mnhOneClickQualificationK8;
      }

      if(window.location.search?.includes('MN=Y') || window.sessionStorage.getItem('isMidnight') === 'true') {
        fiosQualUrl = fiosQualUrl +'?isMnFlow=Y'
      }

      api(fiosQualUrl, 'POST', JSON.stringify(reqObj)).then(response => {
        if (response && response.meta && response.meta.code && (response.meta.code.toString().indexOf('200') !== -1) && response.data) {
          resolve(response.data);
        } else {
          console.log("Error response on fios qualification call ", response);
          reject(response);
        }
      })
        .catch(error => {
          console.log("Error on fios qualification call ", error);
          reject(error);
        })
    } catch (ex) {
      console.log("Exception on fios qualification call ", ex);
      reject(ex);
    }
  });

};

export const postToLearn = (accountNumber, dispatch) => {
  try {
    let reqData = accountNumber;
    var learnUrl = window.location.host.includes('www.verizon.com')?'https://www.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html':'https://wwwawssit.ebiz.verizon.com/content/verizon/personal/services/fivegoneclick.nocache.html';
    axios({
      url: learnUrl,
      method: 'POST',
      data: reqData
    })
      .then(response => {
        console.log("Response from post to learn ", response);
      })
      .catch(error => {
        console.log("Error on post to learn ", error);
      });

  } catch (ex) {
    console.log("Exception on post to learn ", ex);
  }
}

//XML responses
export const setAddressId = (addressId, dispatch) => {
  dispatch({
    type: 'SET_ADDRESS_ID',
    value: addressId
  });
};

export const setMtn = (mtn, dispatch) => {
  dispatch({
    type: 'SET_MTN',
    value: mtn
  });
};

export const setResponseValue = (type, value, dispatch) => {
  dispatch({
    type: type,
    value: value
  });
};

export const saveMarketingProfileResp = (respXML, addressId, dispatch) => {
  try {
    let saveUrl = apiUrl().mnhOneClickMarketingProfileSave + addressId;
    api(saveUrl, 'POST', respXML, 'application/xml').then(response => {
      console.log("Response from makerting profile save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: 'SET_MARKETING_PROFILE_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on marketing profile save");
      })
  } catch (ex) {
    console.log("Exception on marketing profile save ", ex);
  }
}
export const saveECMarketingProfileResp = (respXML, addressId, dispatch) => {
  try {
    let saveUrl = apiUrl().ecMarketingProfileSave + addressId;
    api(saveUrl, 'POST', respXML, 'application/xml').then(response => {
      console.log("Response from makerting profile save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: 'SET_MARKETING_PROFILE_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on marketing profile save");
      })
  } catch (ex) {
    console.log("Exception on marketing profile save ", ex);
  }
}

export const saveLoopQualResp = (respXML, addressId, dispatch) => {
  try {
    let saveUrl = apiUrl().mnhOneClickLoopQualSave + addressId;
    api(saveUrl, 'POST', respXML, 'application/xml').then(response => {
      console.log("Response from loopQual resp save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: 'SET_LOOP_QUAL_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on loopQual resp save");
      })
  } catch (ex) {
    console.log("Exception on loopQual resp save ", ex);
  }
}
export const saveECLoopQualResp = (respXML, addressId, dispatch) => {
  try {
    let saveUrl = apiUrl().ecLoopQualSave + addressId;
    api(saveUrl, 'POST', respXML, 'application/xml').then(response => {
      console.log("Response from loopQual resp save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: 'SET_LOOP_QUAL_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on loopQual resp save");
      })
  } catch (ex) {
    console.log("Exception on loopQual resp save ", ex);
  }
}
export const saveJsonResp = (respJson, visitId, dispatch, flowtype) => {
  try {
    let Json = JSON.stringify(JSON.parse(respJson));
    let saveUrl = ''
    if (flowtype === "SSPGRID")
      saveUrl = apiUrl().SSPGrid + visitId;
    else if (flowtype === "PEGA")
      saveUrl = apiUrl().ecpegarecommenation + visitId;
    api(saveUrl, 'POST', Json).then(response => {
      console.log("Response from saveJsonResp resp save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: flowtype + '_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on saveJsonResp resp save");
      })
  } catch (ex) {
    console.log("Exception on saveJsonResp resp save ", ex);
  }
}
export const saveCRMMResp = (respXML, visitid, dispatch, resptype) => {
  try {
    let saveUrl = '';
    if (resptype == "CRMMSA")
      saveUrl = apiUrl().eccrmmstandalone + visitid;
    else if (resptype == "CRMMBUNDLE")
      saveUrl = apiUrl().eccrmmbundle + visitid;
    else if (resptype == "CRMMPROMO")
      saveUrl = apiUrl().eccrmmpromos + visitid;
    else if (resptype == "CRMMPROFILE")
      saveUrl = apiUrl().eccrmmprofileproduct + visitid;
    api(saveUrl, 'POST', respXML, 'application/xml').then(response => {
      console.log("Response from saveCRMMResp resp save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: resptype + '_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on saveCRMMResp resp save");
      })
  } catch (ex) {
    console.log("Exception on saveCRMMResp resp save ", ex);
  }
}

export const saveLocusAddressValidationResp = (resp, mtn, dispatch) => {
  try {
    let saveUrl = apiUrl().mnhOneClickLocusAddressValidationSave + mtn;
    api(saveUrl, 'POST', JSON.stringify(JSON.parse(resp))).then(response => {
      console.log("Response from locus address validation resp save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: 'SET_LOCUS_ADDRESS_VALIDATION_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on locus address validation resp save");
      })
  } catch (ex) {
    console.log("Exception on locus address validation resp save ", ex);
  }
}
export const setCookie = (cookies, data, props) => {
  try {
    let domain = "localhost";
    if (document.location.href.indexOf("localhost") > -1) {
      //domain="verizon.com";
      cookies.set('visit_id', data.visit_id, { path: '/', 'domain': domain });
      cookies.set('visitor_id', data.visitor_id, { path: '/', 'domain': domain });
    }
    props.dispatch({ type: "UPDATE_VISITID", value: { visitId: data.visit_id, visitorId: data.visitor_id } });
    props.location && props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
  }
  catch (ex) {
    console.log("Exception on setCookie change app action ", ex);
  }
}
export const updateVisitId = (dispatch, value) => {
  dispatch({ type: "UPDATE_VISITID", value });
}

export const saveOneCreditResp = (resp, mtn, dispatch) => {
  try {
    let saveUrl = apiUrl().mnhOneClickOneCreditSave + mtn;
    api(saveUrl, 'POST', JSON.stringify(JSON.parse(resp))).then(response => {
      console.log("Response from one credit resp save ", response);
      let callStatus = response && response.data;
      if (callStatus) {
        dispatch({
          type: 'SET_ONE_CREDIT_RESP_SAVE_CALL_STATUS',
          value: response.data
        });
      }
    })
      .catch(error => {
        console.log("Error on one credit resp save");
      })
  } catch (ex) {
    console.log("Exception on one credit resp save ", ex);
  }
}

export const setWirelessDataToken = (token, dispatch) => {
  dispatch({
    type: 'SET_WIRELESS_DATA_TOKEN',
    value: token
  });
};

export const encryptWirelessDataToken = (token, dispatch) => {
  try {
    let encryptUrl = apiUrl().mnhOneClickEncryptWirelessDataToken;
    api(encryptUrl, 'POST', JSON.stringify(JSON.parse(token))).then(response => {
      if (response && response.meta && response.meta.code.toString().indexOf('200') !== -1 && response.data) {
        dispatch({
          type: 'SET_WIRELESS_DATA_TOKEN_ENCRYPT_STATUS',
          value: response.meta.description
        });
        dispatch({
          type: 'SET_VZW_ACCOUNT_NUMBER',
          value: response.data
        })
      } else {
        console.log("Error response on wireless data token encrypt ", response)
      }
    })
      .catch(error => {
        console.log("Error on wireless data token encrypt ", error);
      });
  } catch (ex) {
    console.log("Exception on wireless data token encrypt ", ex);
  }
}

export const setMHToken = (token, dispatch) => {
  dispatch({
    type: 'SET_MHTOKEN_DETAILS',
    value: token
  });
};

export const setVisitProfileJson = (visitProfile, dispatch) => {
  dispatch({
    type: 'SET_VISIT_PROFILE_DETAILS',
    value: visitProfile
  });
};

export const setPromoKeyWord =(value, dispatch) =>{
  dispatch({
    type: 'SET_PROMO_KEY_WORD',
    value: value
  });
}

export const showPromoKeyWord =(value, dispatch) =>{
  dispatch({
    type: 'SHOW_PROMO_KEY_WORD',
    value: value
  });
}